import React from 'react'
import styled from 'styled-components'
// import Checkbox from '@sl/ui-library/molecules/Checkbox'

const LegalStyle = styled.p`
  font-size: 0.875rem;
  padding: 0;
  margin: 0;

  label {
    display: flex;
    align-items: flex-start;
  }

  input {
    margin-right: 6px;
  }
`

const Legal = ({ value, handleChange }) => (
  <LegalStyle>
    <label htmlFor="optin-legal">
      <input id="optin-legal" name="legal" checked={value} style={{ width: '3rem' }} type="checkbox" onChange={handleChange} />
      <span>
        J&apos;accepte que mes informations soient traitées par Digital Classifieds France et communiquées à son partenaire Des Bras en Plus afin d&apos;obtenir un devis de
        déménagement.
      </span>
    </label>
  </LegalStyle>
)
export default Legal
